import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';
import {useDocumentTagsQueryCache} from './use-document-tags-query';
import {useAvailableTagsQueryCache} from './use-available-tags-query';
import {showErrorNotification} from '../../../../../providers/notifications-center/show-notification';

export interface Params {
    accession: string;
    tag: string;
    isPrivate: boolean;
}

function removeDocTagRequest({accession, isPrivate, tag}: Params) {
    return apiClient.delete({
        path: `editor-documents-service/api/documents/${accession}/tags`,
        query: {'is-private-tags': isPrivate},
        parameters: [tag]
    });
}

export function useRemoveTagMutation() {
    const documentTagsQueryCache = useDocumentTagsQueryCache();
    const availableTagsQueryCache = useAvailableTagsQueryCache();

    return useMutation({
        mutationFn: removeDocTagRequest,
        onMutate: (params: Params) => {
            documentTagsQueryCache.removeTag(params.accession, params.tag, params.isPrivate);
            availableTagsQueryCache.invalidate();
        },
        onError: (error, params) => {
            showErrorNotification()(error);
            documentTagsQueryCache.removeTag(params.accession, params.tag, params.isPrivate);
        }
    });
}
